<template>
	<!-- USER PROFILE CARD 2 - MINIMAL -->
	<div
		class="chat__contact flex items-center px-2 pt-4 pb-2"
		:class="{
			'bg-primary-gradient text-white shadow-lg': isActiveChatUser,
		}"
	>
		<div class="contact__avatar mr-1">
			<vs-avatar class="border-2 border-solid border-white" :src="photoURL" size="42px" />
		</div>
		<div class="contact__container w-full flex items-center justify-between overflow-hidden">
			<div class="contact__info flex flex-col truncate w-5/6">
				<h5 class="font-semibold" :class="{'text-white': isActiveChatUser}">
					{{ resource.username }}
				</h5>
				<span class="truncate">{{ resource.name }}</span>
			</div>

			<div class="chat__contact__meta flex self-start flex-col items-end w-1/6">
				<div class="flex justify-center">
					<feather-icon
						class="mr-4"
						:title="$t('general.Status')"
						:icon="resource_local.transmissionIcon"
						:svgClasses="transmissionColorIcon"
					/>
					<feather-icon
						class="mr-4"
						:title="$t('Alarm.BatteryLevel')"
						:icon="batteryLevelIcon.icon"
						:svgClasses="'h-8 w-8 stroke-current ' + batteryLevelIcon.color"
					/>
					<feather-icon
						class="mr-4"
						icon="Navigation2Icon"
						:title="$t('general.Navigation')"
						@click="LocateMarker"
					/>
					<vs-icon
						class="mt-1"
						size="small"
						:title="$t('general.GpsStatus')"
						:icon="gpsIcon"
						:color="gpsIcon === 'gps_fixed' ? 'primary' : 'secondary'"
					></vs-icon>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import firebase from "firebase/app";
import DateUtils from "@/helpers/DateUtils.js";
import Commons from "@/helpers/commons.js";
/* AIzaSyB7E-c1ZWBHHSpOLueqVxUHkPkgjbC2Im8 customsearchapi */
import {generateInfowindowContentSchedule} from "./infowindowContent.js";

// Import Store Module
import moduleSchedule from "@/store/schedule/moduleSchedule.js";
import moduleMap from "@/store/map/moduleMap.js";

import Tracking from "@/models/Tracking.js";

// Import Static files
import mapMethods from "./mapMethods.js";
import Infowindow from "./Infowindow.vue";
import Vue from "vue";

import {downloadFileFromFirebase} from "@/helpers/firebaseDB.js";
import moduleResource from "@/store/resource/moduleResource.js";
import User from "@/models/User.js";
import {addInfoBubble, addMarkerHereMap, centerHereMap, changeIconInMarkerHereMap, clearMap} from "../../utils/HereMap";

var ComponentClass = Vue.extend(Infowindow);

export default {
	name: "First",
	props: {
		resource: {
			type: Object,
		},
		isActiveChatUser: {type: Boolean},
		lastMessaged: {type: String, default: ""},
		showLastMsg: {type: Boolean, default: false},
		unseenMsg: {type: Number, default: 0},
	},
	components: {Infowindow},
	data: () => ({
		instanceInfo: null,
		database: firebase.database(),
		tracking: new Tracking({}),
		resourceMarker: null,
		resource_local: {
			userImg: null, //require("@/assets/images/portrait/small/avatar-s-12.jpg"),
			name: "Zoila Legore",
			profession: "Backend Dev",
			btn_route_text: "Route",
			btn_schedule_text: "Schedule",
			batteryStatusIcon: "BatteryChargingIcon",
			batteryIcon: "BatteryIcon",
			footer_text_1: Math.floor(Math.random() * 100),
			transmissionIcon: "WifiIcon",
			isStarred: true,
			progress_done_per: 0,
			current_progress: 0,
			progress_goal: 0,
		},
		cardToggle: false,
		cardOpen: false,
		featuresOpen: false,
		backgroundLoading: "primary",
		colorLoading: "#fff",
		// Data for program route
		currentDay: new Date(),
		markerArray: [],
		possitionArray: [],
		// config loading button
		backgroundBtnLoading: "success",
		colorBtnLoading: "#fff",
		// propiedades para animaciondel marker
		currentPosition: {},
		numDeltas: 100,
		delay: 10, //milliseconds,
		i: 0,
		deltaLat: null,
		deltaLng: null,
		avatar: "",
		messages: [],
		total: 0,
		userSession: new User(),
	}),
	watch: {
		tracking(val) {
			if (this.resourceMarker) {
				this.changeMarkerPosition({lat: val.cy, lng: val.cx});
				this.changeMarkerColor();
				this.tracking.calculateHowLongLastTransmision();
				this.resource_data.battery = this.tracking.battery;
				this.resource_data.gps = this.tracking.gps;
				if (this.instanceInfo !== null) {
					this.instanceInfo.tracking = this.tracking;
				}
			}
		},
		lastTransmissionMinutes() {
			if (!this.resourceMarker) {
				return;
			}
			changeIconInMarkerHereMap(this.resourceMarker, mapMethods.generateMarkerIconResource(this.tracking));
		},
	},
	filters: {
		capitalizeFilter: function (value) {
			if (!value) return "";
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1);
		},
	},
	mounted() {
		this.getResourcePhoto();
	},
	created() {
		if (!moduleSchedule.isRegistered) {
			this.$store.registerModule("moduleSchedule", moduleSchedule);
			moduleSchedule.isRegistered = true;
		}

		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}

		const starCountRef = this.database.ref(
			"tracking/" + this.resource_data.company_id + "/" + this.resource_data.positionrecord_id
		);

		starCountRef.once("value").then((snapshot) => {
			const resourceTracking = snapshot.val();
			if (resourceTracking) {
				const {cx, cy} = resourceTracking;
				this.addMarker(parseFloat(cy), parseFloat(cx));
			}
		});

		starCountRef.on("value", (snapshot) => {
			const resourceTracking = snapshot.val();
			if (resourceTracking) {
				this.tracking = new Tracking(resourceTracking);
			}
		});
	},
	beforeDestroy() {
		if (this.resourceMarker) {
			this.resourceMarker.setData(null);
		}
	},
	computed: {
		photoURL() {
			return this.avatar;
		},
		routeBtnId() {
			return "btn-draw-programed-route-" + this.resource_data.id;
		},
		scheduleBtnId() {
			return "btn-show-schedule-" + this.resource_data.id;
		},
		executedRouteBtnId() {
			return "btn-draw-executed-route-" + this.resource_data.id;
		},
		resource_data() {
			return this.resource;
		},
		firtLetter() {
			return this.resource_data.name.substring(0, 1).toUpperCase();
		},
		batteryLevelIcon() {
			return this.tracking.getBatteryIcon();
		},
		lastTransmission() {
			// 'Tue, 18 Mar 2025 19:35:52 GMT'
			const newDate = new Date(this.tracking.date);
			return DateUtils.relativeTime(newDate);
		},
		lastTransmissionMinutes() {
			return this.tracking.howLong;
		},
		gpsIcon() {
			return this.tracking.gps === "on" ? "gps_fixed" : "gps_off";
		},
		transmissionText() {
			return this.tracking.getTransmissionText();
		},
		transmissionColorIcon() {
			return this.tracking.getTransmissionColor();
		},
		fullName() {
			return (
				"\xa0\xa0\xa0\xa0" +
				this.capitalize(this.resource_data.name) +
				" " +
				this.capitalize(this.resource_data.lastname)
			);
		},
		dateInitComputed: {
			get() {
				return DateUtils.toDefaultDateTime(this.currentDay, "YYYY-MM-DD");
			},
		},
		currentProgressColor() {
			let percent = this.resource_local.current_progress;
			if (percent >= 0 && percent <= 25) {
				return "danger";
			} else if (percent > 25 && percent < 75) {
				return "warning";
			} else {
				return "success";
			}
		},
	},
	methods: {
		openLoadingInDivContent(idDivConten) {
			this.$vs.loading({
				container: idDivConten,
				background: this.backgroundBtnLoading,
				color: this.colorLoading,
				scale: 0.45,
			});
		},
		closeLoadingInDivContent(idDivConten) {
			this.$vs.loading.close(`${idDivConten} > .con-vs-loading`);
		},
		toggleFeatures() {
			if (this.resource_local.progress_goal <= 0) {
				this.calculateEventsProgress();
			}
			this.featuresOpen = !this.featuresOpen;
		},
		toggleCard() {
			this.cardOpen = !this.cardOpen;
		},
		doSomething(val) {
			this.cardToggle = val;
		},
		closeCardAnimationDemo(card, eve) {
			card.removeRefreshAnimation(3000);
			//card.toggleContent(true)
		},
		openExportPopup() {
			this.$emit("openExportPopupEmit");
		},
		async executedRoute() {
			const payload = {
				init_date: this.dateInitComputed,
				end_date: this.dateInitComputed,
				resources_id: [this.resource_data.id],
				distance: 0.1,
			};
			Commons.openLoadingButton.call(this, this.executedRouteBtnId);
			try {
				const result = await this.$store.dispatch("moduleMap/getExecutedRoute", payload);
				Commons.closeLoadingButton.call(this, this.executedRouteBtnId);
				mapMethods.drawExecuteRoute.call(this, result.data, this.$store.state.moduleMap.optionsExecutedRoute);
			} catch (error) {
				Commons.closeLoadingButton.call(this, this.executedRouteBtnId);
				this.$vs.notify({
					color: "warning",
					title: this.$t("MapModule.GenerateRoute.Title"),
					text: this.$t("MapModule.GenerateRoute.Text"),
				});
				throw new Error(error);
			}
		},
		programmedRoute() {
			Commons.openLoadingButton.call(this, this.routeBtnId);
			const payload = {
				init_date: this.dateInitComputed,
				end_date: this.dateInitComputed,
				resource_id: this.resource_data.id,
			};
			this.$store
				.dispatch("moduleSchedule/fetchEventsByResourceId", payload)
				.then((res) => {
					Commons.closeLoadingButton.call(this, this.routeBtnId);
					mapMethods.drawProgramedRoute.call(
						this,
						res.data.records,
						this.$store.state.moduleMap.optionsProgramedRoute,
						true
					);
				})
				.catch((err) => {
					Commons.closeLoadingButton.call(this, this.routeBtnId);
					this.$vs.notify({
						color: "danger",
						title: this.$t("MapModule.ErrorGenerateAppointment.Title"),
						text: this.$t("MapModule.ErrorGenerateAppointment.Text"),
					});
					throw new Error(err);
				});
		},
		// Retorna un entero aleatorio entre min (incluido) y max (excluido)
		// ¡Usando Math.round() te dará una distribución no-uniforme!
		getRandomInt(min, max) {
			return Math.floor(Math.random() * (max - min)) + min;
		},
		addMarker(lat, lng) {
			this.currentPosition = {lat, lng};
			this.resource_data.battery = this.tracking.battery;
			this.resource_data.gps = this.tracking.gps;
			// Opciones
			let options = {
				drag: false,
				icon: mapMethods.generateMarkerIconResource(this.tracking),
				title: this.$t("MapModule.CurrentPosition"),
				label: {
					text: "A",
					color: "#fff",
					fontSize: "11.0px",
				},
				infoWindow: {
					content: this.mountInfowindowComponent(),
				},
			};
			this.resourceMarker = addMarkerHereMap(lat, lng, options, true);
			addInfoBubble(this.resourceMarker, options.infoWindow.content);
		},
		cleanInfowindow() {
			if (this.instanceInfo !== null) {
				this.instanceInfo.$destroy();
				this.instanceInfo = null;
			}
		},
		mountInfowindowComponent() {
			this.cleanInfowindow();
			if (this.instanceInfo) {
				this.instanceInfo.$destroy();
			}
			this.instanceInfo = new ComponentClass({
				propsData: {
					resourceData: this.resource_data,
					tracking: this.tracking,
				},
			});
			this.instanceInfo.$mount();
			return this.instanceInfo.$el;
		},
		addMarkerRoute(lat, lng, infoWindowData) {
			let options = {
				drag: false,
				icon: mapMethods.generateMarkerIconEvent(infoWindowData.event_status_id),
				title: this.$t("MapModule.CurrentPosition"),
				label: {
					text: "A",
					color: "#fff",
					fontSize: "11.0px",
				},
				infoWindow: {
					content: generateInfowindowContentSchedule(infoWindowData),
				},
				infoLatLng: {lat, lng},
			};
			let newMarker = addMarkerHereMap(lat, lng, options, true);
			this.possitionArray.push({lat, lng});
			this.markerArray.push(newMarker);
		},
		changeMarkerPosition(newPosition) {
			this.transition(newPosition);
		},
		changeMarkerColor() {
			const newIconMarker = mapMethods.generateMarkerIconResource(this.tracking);
			changeIconInMarkerHereMap(this.resourceMarker, newIconMarker);
		},
		capitalize(value) {
			if (!value) return "";
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1);
		},
		toggleMapSidebar(val = false) {
			this.$store.dispatch("moduleMap/changeToggleMapSidebar", val);
		},
		getEvents(resource_id) {
			Commons.openLoadingButton.call(this, this.scheduleBtnId);
			const payload = {
				init_date: this.dateInitComputed,
				end_date: this.dateInitComputed,
				resource_id: resource_id,
			};
			this.$store
				.dispatch("moduleSchedule/fetchEventsByResourceId", payload)
				.then((res) => {
					setTimeout(() => {
						this.openExportPopup();
					}, 500);
					Commons.closeLoadingButton.call(this, this.scheduleBtnId);
				})
				.catch((err) => {
					Commons.closeLoadingButton.call(this, this.scheduleBtnId);
					throw new Error(err);
				});
		},
		transition(newPosition) {
			this.i = 0;
			this.deltaLat = (newPosition.lat - this.currentPosition.lat) / this.numDeltas;
			this.deltaLng = (newPosition.lng - this.currentPosition.lng) / this.numDeltas;
			this.moveMarker();
		},
		moveMarker() {
			this.currentPosition.lat += this.deltaLat;
			this.currentPosition.lng += this.deltaLng;
			if (isNaN(this.currentPosition.lat)) return;
			this.resourceMarker.setGeometry({
				lat: this.currentPosition.lat,
				lng: this.currentPosition.lng,
			});
			// centerHereMap(this.currentPosition.lat, this.currentPosition.lng, null);
			if (this.i != this.numDeltas) {
				this.i++;
				setTimeout(this.moveMarker, this.delay);
			}
		},
		calculateEventsProgress() {
			const payload = {
				init_date: this.dateInitComputed,
				end_date: this.dateInitComputed,
				resource_id: this.resource_data.id,
			};
			this.$store
				.dispatch("moduleSchedule/fetchEventsByResourceId", payload)
				.then((res) => {
					if (res.data.records) {
						this.resource_local.progress_goal = res.data.records.length;
						const progress = res.data.records.filter((element) => element.status_id === 8);
						this.resource_local.progress_done_per = progress.length;
						this.resource_local.current_progress =
							(progress.length * 100) / this.resource_local.progress_goal;
					}
				})
				.catch((err) => {
					throw new Error(err);
				});
		},
		getResourcePhoto() {
			const url = this.resource.img_url;
			if (!url) {
				return;
			}
			downloadFileFromFirebase(url)
				.then((res) => {
					this.avatar = res;
				})
				.catch((error) => {});
		},
		LocateMarker() {
			const lat = parseFloat(this.tracking.cy);
			const lng = parseFloat(this.tracking.cx);
			if (!Number.isNaN(lat)) {
				centerHereMap(lat, lng, {zoom: 18});
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Error"),
					text: this.$t("MapModule.NoLocate"),
					time: 4000,
				});
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.custom-avatar {
	span {
		font-size: 55px;
	}
}

.infowindow-avatar {
	width: 100px;
	border-radius: 50%;
}

.cursor-pointer {
	cursor: pointer;
}

.margin-less {
	margin-right: -15px;
}

.infowindow-avatar {
	display: flex;
	justify-content: space-around;
	width: auto;
	align-items: center;
}
</style>
